import BOLD_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_text_bold.svg';
import ITALIC_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_text_italic.svg';
import UNDERLINE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_text_underline.svg';
import DELETELINE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_text_deleteline.svg';
import HORIZONTAL_LEFT_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_alignleft.svg';
import HORIZONTAL_RIGHT_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_alignright.svg';
import HORIZONTAL_CENTER_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_aligncenter.svg';
import HORIZONTAL_JUSTIFY_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_justify.svg';
import HORIZONTAL_DISTRIBUTE_ICON from '@tencent/docs-design-resources/pc/svg/scatteralignment_outline_light_24.svg';
import VERTICAL_TOP_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_top.svg';
import VERTICAL_CENTER_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_middle.svg';
import VERTICAL_BOTTOM_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_end.svg';
import INCREASE_INDENT_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_indent_increase.svg';
import REDUCE_INDENT_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_indent_decrease.svg';
import ITEM_NUM_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_itemdot.svg';
import DIGIT_NUM_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_itemnumber.svg';
import ROW_SPACE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_line_spacing.svg';
import DROPDOWN_ICON from './dropdown.svg';
import ADD_GROUP_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_group.svg';
import REMOVE_GROUP_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_ungroup.svg';
import MOVE_TOP_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_arrange_bring_to_forward.svg';
import MOVE_BOTTOM_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_arrange_bring_to_backward.svg';
import MOVE_UP_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_arrange_bring_to_front.svg';
import MOVE_DOWN_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_arrange_bring_to_back.svg';
import ALIGN_DISTRIBUTE_HORIZONTAL_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_align_distribution_horizontally.svg';
import ALIGN_DISTRIBUTE_VERTICAL_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_align_distribution_vertically.svg';
import ALIGN_VERTICAL_TOP_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_align_top.svg';
import ALIGN_VERTICAL_CENTER_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_align_middle.svg';
import ALIGN_VERTICAL_BOTTOM_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_align_bottom.svg';
import ALIGN_HORIZONTAL_LEFT_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_align_left.svg';
import ALIGN_HORIZONTAL_CENTER_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_align_center.svg';
import ALIGN_HORIZONTAL_RIGHT_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_align_right.svg';
import FONT_SIZE_INCREASE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_increase_font_size.svg';
import FONT_SIZE_DECREASE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_decrease_font_size.svg';
import FONT_BACK_COLOR_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_text_highlight.svg';
import CONVERT_BTN_ICON from '@tencent/docs-design-resources/pc/svg/floatingtoolbar_replacephoto.svg';
// 边框
import TABLE_BOXICON_1_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_cell_allborder.svg';
import TABLE_BOXICON_3_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_cell_cross_border.svg';
import TABLE_BOXICON_4_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_cell_length_border.svg';
import TABLE_BOXICON_5_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_cell_outborder.svg';
import TABLE_BOXICON_6_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_cell_left_border.svg';
import TABLE_BOXICON_7_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_cell_top_border.svg';
import TABLE_BOXICON_8_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_cell_right_border.svg';
import TABLE_BOXICON_9_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_cell_bottom_border.svg';
import TABLE_BOXICON_10_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_cell_noborder.svg';
// 图片
import UPLOAD_ICON from './upload.svg';
import PICTURE_TAILOR from './picture-tailor.svg';
// 箭头粗细
import LEFT_ARROW_SIZE1 from './left-arrow-size1.svg';
import LEFT_ARROW_SIZE2 from './left-arrow-size2.svg';
import LEFT_ARROW_SIZE3 from './left-arrow-size3.svg';
import LEFT_ARROW_SIZE4 from './left-arrow-size4.svg';
import LEFT_ARROW_SIZE5 from './left-arrow-size5.svg';
import LEFT_ARROW_SIZE6 from './left-arrow-size6.svg';
import LEFT_ARROW_SIZE7 from './left-arrow-size7.svg';
import LEFT_ARROW_SIZE8 from './left-arrow-size8.svg';
import LEFT_ARROW_SIZE9 from './left-arrow-size9.svg';
import RIGHT_ARROW_SIZE1 from './right-arrow-size1.svg';
import RIGHT_ARROW_SIZE2 from './right-arrow-size2.svg';
import RIGHT_ARROW_SIZE3 from './right-arrow-size3.svg';
import RIGHT_ARROW_SIZE4 from './right-arrow-size4.svg';
import RIGHT_ARROW_SIZE5 from './right-arrow-size5.svg';
import RIGHT_ARROW_SIZE6 from './right-arrow-size6.svg';
import RIGHT_ARROW_SIZE7 from './right-arrow-size7.svg';
import RIGHT_ARROW_SIZE8 from './right-arrow-size8.svg';
import RIGHT_ARROW_SIZE9 from './right-arrow-size9.svg';
// 渐变按钮
import LINEAR_GRADIENT_ICON from './linear-gradual.svg';
import RADIAL_GRADIENT_ICON from './radial-gradual.svg';
// 边框草绘
import SKETCH_STYLE_NONE_ICON from './sketch-style-none.svg';
import SKETCH_STYLE_CURVED_ICON from './sketch-style-curved.svg';
import SKETCH_STYLE_FREEHAND_ICON from './sketch-style-freehand.svg';
import SKETCH_STYLE_SCRIBBLE_ICON from './sketch-style-scribble.svg';

export {
    BOLD_ICON,
    ITALIC_ICON,
    UNDERLINE_ICON,
    DELETELINE_ICON,
    HORIZONTAL_LEFT_ICON,
    HORIZONTAL_RIGHT_ICON,
    HORIZONTAL_CENTER_ICON,
    HORIZONTAL_JUSTIFY_ICON,
    HORIZONTAL_DISTRIBUTE_ICON,
    VERTICAL_TOP_ICON,
    VERTICAL_CENTER_ICON,
    VERTICAL_BOTTOM_ICON,
    INCREASE_INDENT_ICON,
    REDUCE_INDENT_ICON,
    ITEM_NUM_ICON,
    DIGIT_NUM_ICON,
    ROW_SPACE_ICON,
    DROPDOWN_ICON,
    UPLOAD_ICON,
    ADD_GROUP_ICON,
    REMOVE_GROUP_ICON,
    MOVE_TOP_ICON,
    MOVE_BOTTOM_ICON,
    MOVE_UP_ICON,
    MOVE_DOWN_ICON,
    ALIGN_DISTRIBUTE_HORIZONTAL_ICON,
    ALIGN_DISTRIBUTE_VERTICAL_ICON,
    ALIGN_VERTICAL_TOP_ICON,
    ALIGN_VERTICAL_CENTER_ICON,
    ALIGN_VERTICAL_BOTTOM_ICON,
    ALIGN_HORIZONTAL_LEFT_ICON,
    ALIGN_HORIZONTAL_CENTER_ICON,
    ALIGN_HORIZONTAL_RIGHT_ICON,
    FONT_SIZE_INCREASE_ICON,
    FONT_SIZE_DECREASE_ICON,
    FONT_BACK_COLOR_ICON,
    TABLE_BOXICON_1_ICON,
    TABLE_BOXICON_3_ICON,
    TABLE_BOXICON_4_ICON,
    TABLE_BOXICON_5_ICON,
    TABLE_BOXICON_6_ICON,
    TABLE_BOXICON_7_ICON,
    TABLE_BOXICON_8_ICON,
    TABLE_BOXICON_9_ICON,
    TABLE_BOXICON_10_ICON,
    PICTURE_TAILOR,
    LEFT_ARROW_SIZE1,
    LEFT_ARROW_SIZE2,
    LEFT_ARROW_SIZE3,
    LEFT_ARROW_SIZE4,
    LEFT_ARROW_SIZE5,
    LEFT_ARROW_SIZE6,
    LEFT_ARROW_SIZE7,
    LEFT_ARROW_SIZE8,
    LEFT_ARROW_SIZE9,
    RIGHT_ARROW_SIZE1,
    RIGHT_ARROW_SIZE2,
    RIGHT_ARROW_SIZE3,
    RIGHT_ARROW_SIZE4,
    RIGHT_ARROW_SIZE5,
    RIGHT_ARROW_SIZE6,
    RIGHT_ARROW_SIZE7,
    RIGHT_ARROW_SIZE8,
    RIGHT_ARROW_SIZE9,
    CONVERT_BTN_ICON,
    LINEAR_GRADIENT_ICON,
    RADIAL_GRADIENT_ICON,
    SKETCH_STYLE_NONE_ICON,
    SKETCH_STYLE_CURVED_ICON,
    SKETCH_STYLE_FREEHAND_ICON,
    SKETCH_STYLE_SCRIBBLE_ICON,
};
